console.log('app/assets/packs/application.js');
import { Turbo } from "@hotwired/turbo-rails"
import "./controllers"

// Drive link navigation only: forms, data-method and data-remote stay owned by jquery_ujs
Turbo.config.forms.mode = "off"
